import { OfferType } from "@1games-ru/region-shared/dist/enums/offer/offer";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";

export enum OfferMode {
  Creator = "creator",
  Resolver = "resolver",
}

export type OfferCharacter = {
  id: number;
  name: string;
  avatar: string;
};

type OfferState = {
  type: OfferType | null;
  mode: OfferMode | null;
  creator: {
    targetCharacter: OfferCharacter;
  } | null;
  resolver: {
    uuid: string;
    targetId: number;
    baseCharacter: OfferCharacter;
    price: number;
  } | null;
};

const initialState: OfferState = {
  type: null,
  mode: null,
  creator: null,
  resolver: null,
};

const offerSlice = createSlice({
  name: "offerSlice",
  initialState,
  reducers: {
    setOfferResolver: (
      state,
      action: PayloadAction<{ type: OfferType; resolver: OfferState["resolver"] }>,
    ) => {
      state.mode = OfferMode.Resolver;
      state.type = action.payload.type;
      state.resolver = action.payload.resolver;
    },
    setOfferCreator: (
      state,
      action: PayloadAction<{ type: OfferType; creator: OfferState["creator"] }>,
    ) => {
      state.mode = OfferMode.Creator;
      state.type = action.payload.type;
      state.creator = action.payload.creator;
    },
    clearOffer: (state) => {
      state.type = null;
      state.mode = null;
      state.creator = null;
      state.resolver = null;
    },
  },
});

export const offerTypeSelector = (state: RootState) => state.offer.type;
export const offerModeSelector = (state: RootState) => state.offer.mode;
export const offerResolverSelector = (state: RootState) => state.offer.resolver;
export const offerCreatorSelector = (state: RootState) => state.offer.creator;
export const offerReducer = offerSlice.reducer;
export const { setOfferResolver, setOfferCreator, clearOffer } = offerSlice.actions;
